<template>
  <div
    class="min-h-screen flex items-center justify-center px-4 bg-gradient-to-b from-sky-50 via-white to-sky-100 dark:from-[#020617] dark:via-[#020617] dark:to-[#020617]"
  >
    <div
      class="w-full max-w-md rounded-3xl border border-black/5 dark:border-white/10 bg-white/95 dark:bg-zinc-950/85 shadow-[0_26px_80px_rgba(15,23,42,0.55)] backdrop-blur-xl px-6 py-7 sm:px-8 sm:py-9 text-center space-y-6"
    >
      <div class="inline-flex items-center gap-2 rounded-full bg-sky-50 text-sky-700 px-3 py-1 text-[11px] font-semibold tracking-[0.18em] uppercase dark:bg-sky-500/10 dark:text-sky-200">
        <span class="relative flex h-3 w-3">
          <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-sky-400 opacity-60"></span>
          <span class="relative inline-flex h-3 w-3 rounded-full bg-sky-500"></span>
        </span>
        <span>Finishing subscription</span>
      </div>

      <div class="space-y-2">
        <h1 class="text-xl sm:text-2xl font-semibold tracking-tight text-zinc-950 dark:text-zinc-50">
          Almost there
        </h1>
        <p class="text-sm sm:text-[15px] leading-relaxed text-zinc-600 dark:text-zinc-300">
          {{ msg }}
        </p>
      </div>

      <div class="flex items-center justify-center gap-2 text-[11px] text-zinc-500 dark:text-zinc-500">
        <span class="h-1.5 w-1.5 rounded-full bg-emerald-400"></span>
        <span>Do not close this tab until the process is complete.</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const API = 'https://backend.nexgridco.com'
const route = useRoute()
const router = useRouter()
const msg = ref('Please wait while we confirm your subscription…')

function token() {
  try {
    return localStorage.getItem('token') || sessionStorage.getItem('token') || ''
  } catch {
    return ''
  }
}

onMounted(async () => {
  const sid = route.query.session_id
  if (!sid) {
    msg.value = 'Invalid session. You can start again from the Pricing page.'
    setTimeout(() => router.replace('/pricing'), 1500)
    return
  }

  try {
    const headers = { Authorization: `Bearer ${token()}` }
    const res = await fetch(
      `${API}/billing/activate?session_id=${encodeURIComponent(String(sid))}`,
      { headers, credentials: 'include' }
    )

    if (res.ok) {
      msg.value = 'All set! Redirecting you to your dashboard…'
      setTimeout(() => router.replace('/dashboard'), 900)
    } else {
      msg.value = 'We could not complete your subscription. You can try again from Pricing.'
      setTimeout(() => router.replace('/pricing'), 1500)
    }
  } catch {
    msg.value = 'Something went wrong. Please try again from the Pricing page.'
    setTimeout(() => router.replace('/pricing'), 1500)
  }
})
</script>
